import { useEffect, useState } from 'preact/hooks';
import { websApi } from '@/api/webs';
import { useToast } from '@/hooks/useToast';
export function useWebLoader(workspaceId, webId) {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [web, setWeb] = useState(null);
    const { showError } = useToast();
    useEffect(() => {
        let active = true;
        (async () => {
            setLoading(true);
            setError(null);
            const res = await websApi.getById(workspaceId, webId);
            if (!active)
                return;
            if (res.data)
                setWeb(res.data);
            else {
                const message = res.error || 'Failed to load web details';
                setError(message);
                showError('Load failed', message);
            }
            setLoading(false);
        })();
        return () => { active = false; };
    }, [workspaceId, webId]);
    return { web, setWeb, loading, error };
}
